import React from "react";
import MessagingTray from "../../../Pages/Home/Message/MessagingTray";
import TodoTray from "../../../Pages/Home/TodoTray/TodoTray";
import NotificationTray from "../../../stories/Components/NotificationSlider/NotificationTray";
import { NAVBAR_SLIDE_OUTS } from "../../../constants";

const EsSliderPopouts = ({ toggleSlideOut, slideOut }) => {
  const close = () => toggleSlideOut(null);

  switch (slideOut) {
    case NAVBAR_SLIDE_OUTS.todos:
      return <TodoTray open close={close} />;
    case NAVBAR_SLIDE_OUTS.messages:
      return <MessagingTray open close={close} />;
    case NAVBAR_SLIDE_OUTS.notifications:
      return <NotificationTray open close={close} />;
    default:
      return null;
  }
};

export default EsSliderPopouts;
